// extracted by mini-css-extract-plugin
export var bookList = "lists-module--bookList--6HMA0";
export var genericList = "lists-module--genericList--WUVXJ";
export var notFoundList = "lists-module--notFoundList--Db7PY";
export var tocList = "lists-module--tocList--BE5uw";